import { helper } from '@ember/component/helper';

import { itemTypeIdsEqual } from 'rise-ui/utils/model/item.js';

export default helper(function itemTypeIdsEqHelper(itemTypeIds) {
  return itemTypeIdsEqual(...itemTypeIds);
});
